export { HeroValueProps } from './HeroValueProps';
